
import {
    ALARM_OR_MOBILISER_OPTIONS,
    CAR_TRANSMISSION_TYPES_OPTIONS,
    NUMBER_OF_DOOR_OPTIONS,
    NUMBER_OF_SEAT_OPTIONS
} from "@constants/dropdown-choices";

import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";

export default function UnKnownRegNumberFields({data, handlers}) {

    return (
        <div className="known-reg-num-block">

            {/* Car's make and model */}

            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 "
                labelText="Car's make and model"
                required={false}
                controlName="carMakeAndModel"
                value={data.carMakeAndModel}
                onChange={handlers.onControlChange}
                inputAttrs={{
                    maxLength: 50
                }}
            />


            <div className="row hidden-box">

                {/* Manufacturer */}

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Manufacturer"
                    required={false}
                    controlName="manufacturerName"
                    value={data.manufacturerName}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

                {/* Model */}

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Model"
                    required={false}
                    controlName="manufacturerModel"
                    value={data.manufacturerModel}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

                {/* Registration Year */}

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Registration Year"
                    required={false}
                    controlName="carRegistrationYear"
                    value={data.carRegistrationYear}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

                {/* Alarms - Immobiliser */}

                <ScrollableDropdownBlock
                    controlName="carAlarmsOrImmobiliser"
                    containerCssClass="col-12 py-3 "
                    labelText="Alarms - Immobiliser"
                    required={false}
                    options={ALARM_OR_MOBILISER_OPTIONS}
                    selectedValues={data.carAlarmsOrImmobiliser}
                    onChange={handlers.onControlChange}
                    helpText=""
                />


                {/* Number of seats */}

                <ScrollableDropdownBlock
                    controlName="carSeatNumber"
                    containerCssClass="col-12 py-3 "
                    labelText="Number of seats"
                    required={false}
                    options={NUMBER_OF_SEAT_OPTIONS}
                    selectedValues={data.carSeatNumber}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* Number of doors */}

                <ScrollableDropdownBlock
                    controlName="carDoorNumber"
                    containerCssClass="col-12 py-3 "
                    labelText="Number of doors"
                    required={false}
                    options={NUMBER_OF_DOOR_OPTIONS}
                    selectedValues={data.carDoorNumber}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* Engine Size in CC */}

                <ScrollableTextBoxBlock
                    type="number"
                    containerCssClass="col-12 py-3 "
                    labelText="Engine Size in CC"
                    required={false}
                    controlName="carEngineSize"
                    value={data.carEngineSize}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

                {/* Transmission Type */}

                <ScrollableDropdownBlock
                    controlName="carTransmissionType"
                    containerCssClass="col-12 py-3 "
                    labelText="Transmission Type"
                    required={true}
                    options={CAR_TRANSMISSION_TYPES_OPTIONS}
                    selectedValues={data.carTransmissionType}
                    onChange={handlers.onControlChange}
                    helpText=""
                />


            </div>


            <div className="row">

                {/* Estimated car value */}

                <ScrollableTextBoxBlock
                    type="number"
                    containerCssClass="col-12 py-3 "
                    labelText="Estimated car value"
                    required={false}
                    controlName="carEstimatedValue"
                    value={data.carEstimatedValue}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />


            </div>

        </div>
    );

}